import type { ApolloError } from '@apollo/client'

import { FacilityFloorPlanQuery } from '@/graphql/generated/operations'

/**
 * True only when the floor-plan query has CONFIRMED the current floor has no
 * plan image (ENG-33744). Loading and error states return false so checkpoint
 * creation is never blocked by a transient query state, and deriving from the
 * live query result (not component state cached across floor switches) means
 * the previous floor's plan can never leak into the current floor's answer.
 */
export const getIsFloorPlanKnownEmpty = (
  isLoading: boolean,
  error: ApolloError | undefined,
  data: FacilityFloorPlanQuery | undefined
): boolean => {
  if (isLoading || error || !data) return false
  const image = data.facility?.floors?.edges?.[0]?.node?.floorPlan?.image
  return !(image && 'url' in image && image.url)
}
